import * as React from "react";
//import React, { useEffect, useState } from "react";
import "./MSList.scss";
import MIPADatePicker from "../Common/datepicker";
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { getId } from 'office-ui-fabric-react/lib/Utilities';
//import { Editor } from "react-draft-wysiwyg";
//import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
//import { convertFromHTML, convertFromRaw, EditorState } from "draft-js"; 
//import { EditorState, ContentState, convertFromHTML, convertToRaw } from 'draft-js'
import {
    getTheme,
  mergeStyleSets,
  FontWeights,
  ContextualMenu,
  //Checkbox,
  //DefaultButton,
  Modal,
  IDragOptions,
  IconButton
  } from 'office-ui-fabric-react';
  import { FontSizes } from '@uifabric/styling';
import { Dropdown, 
    //DropdownMenuItemType, 
    IDropdownOption } 
  from 'office-ui-fabric-react/lib/Dropdown';  
  /*import {
    DirectionalHint,
    IContextualMenuItem
  } from "office-ui-fabric-react/lib/ContextualMenu";
import MIPAChoiceAction from "../Common/ChoiceAction";*/
import {MSListConfig,MSListFieldValue,
    //MSListFiled,
    MSListItem} from '../../Entity/MySettingobj';
import MIPARichTextEdit from "../Common/IGRichEditor";
//import { Helper } from "../../Utils/Helper";
export interface IProps {
    ListInfo: MSListConfig;
    ListItem:MSListItem;
    UpdateMethod;
    UserEmail;
    UserList;  
    closeMethod;  
  }
  const theme = getTheme();
  const contentStyles = mergeStyleSets({
    container: {
      display: 'flex',
      flexFlow: 'column nowrap',
      alignItems: 'stretch'
    },
    header: [
      // tslint:disable-next-line:deprecation
      theme.fonts['xLargePlus'],
      {
        flex: '1 1 auto',
        borderTop: `4px solid ${theme.palette.themePrimary}`,
        color: theme.palette.neutralPrimary,
        display: 'flex',
        fontSize: FontSizes.xLarge,
        alignItems: 'center',
        fontWeight: FontWeights.semibold,
        padding: '12px 12px 14px 24px'
      }
    ],
    body: {
      flex: '4 4 auto',
      padding: '0 24px 24px 24px',
      overflowY: 'hidden',
      selectors: {
        p: {
          margin: '14px 0'
        },
        'p:first-child': {
          marginTop: 0
        },
        'p:last-child': {
          marginBottom: 0
        }
      }
    }
  });
  
  const iconButtonStyles = mergeStyleSets({
    root: {
      color: theme.palette.neutralPrimary,
      marginLeft: 'auto',
      marginTop: '4px',
      marginRight: '2px'
    },
    rootHovered: {
      color: theme.palette.neutralDark
    }
  });
  export default class MSListItemEdit extends React.Component<IProps> {  
    private _titleId: string = getId('title');
    private _subtitleId: string = getId('subText');
    private _dragOptions: IDragOptions = {
                                            moveMenuItemText: 'Move',
                                            closeMenuItemText: 'Close',
                                            menu: ContextualMenu
                                        };
    constructor(props) {
        super(props);    
       this.Itemvalue={...this.props.ListItem};
        }
    public Itemvalue:MSListItem;   
    public state={DetailCalloutVisible:false,ShowEditModal:false,beakWidth: 16,isLoading:false};
    public ignoreDataType=['MaxItems','Computed','Calculated','URL','Counter','Lookup'];
    public render() {
      let rowcss = "ms-Grid-row miparow";
     
    return (
      <div className="mslist">
        <Modal
        //titleAriaId={this._titleId}
        //subtitleAriaId={this._subtitleId}
        isOpen={true}
        onDismiss={()=>{this.props.closeMethod(false)}}
        isBlocking={true}
        containerClassName={contentStyles.container}
        dragOptions={this._dragOptions}
      >
      <div className={contentStyles.header}>
      <span id={this._titleId}>Edit</span>
     
      <IconButton
        styles={iconButtonStyles}
        iconProps={{ iconName: 'Cancel' }}
        ariaLabel="Close popup modal"
        onClick={()=>{this.props.closeMethod(false)}}
      />
      {this.state.isLoading?(
        <div className="mipaloading">&nbsp;</div>
      ):null}
      
      </div>
      
      <div id={this._subtitleId} className={contentStyles.body} style={{minHeight:'70vh',minWidth:'70vw',maxHeight:'80vh',overflow:'auto'}}>
      <div className={rowcss}>                  
          {this.prepareCustomData(rowcss)}
      </div>
      
      
      {/* <div className="ms-Grid-row">
         <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 notebox">
           <ul className="error">
             {this.FromValidationMessages}
           </ul>
           
         </div>
      </div> */}
     
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
              <div className="buttonarea">
              <button onClick={this.UpdateItemData} className="ms-Button ms-Button--default viewswitchbtn plannertask">
                Save
              </button>
              <button 
                className="ms-Button ms-Button--default viewswitchbtn"
                onClick={()=>{this.props.closeMethod(false)}}
              >
                Cancel
              </button>
              </div>
            
          </div>
      </div>
      
      
      </div>
      </Modal>
        </div>
        
      
    );
  }
  public prepareCustomData = rowcss => {
    let data = [];
   
   this.Itemvalue.Fields.map((customitem:MSListFieldValue, index) => {
      if(this.ignoreDataType.indexOf(customitem.FieldType)<0){
        let Rendervalue=null;
        if(customitem.FieldType=='DateTime'){
          Rendervalue=(
            <div
                    className=""
                    title={customitem.FieldTitle}
                  >
                      <label  className="ms-Label">{customitem.FieldTitle}</label>
                    <MIPADatePicker
                      datevalue={customitem.FieldValue}
                      showIcon={false}
                      ChangeDate={date => {
                       customitem.FieldValue=date;
                      }}
                    />
                  </div>
          );
        }
        else if(customitem.FieldType=='Choice'){
            let choicevalue=[];
            let item=this.props.ListInfo.AllFields.filter(f=>f.Name==customitem.FieldName)[0];      
            item['Choices'].forEach(p=>{
            choicevalue.push({key:p,text:p});
            Rendervalue=(
                <Dropdown
                                            label={customitem.FieldTitle}
                                            selectedKey={customitem.FieldValue}
                                            onChange={(event: React.FormEvent<HTMLDivElement>, item: IDropdownOption)=>{  
                                                customitem.FieldValue=item.key.toString(); 
                                                this.setState({changed:true});                                           
                                             
                                            }}
                                            //placeholder={'select status field'}
                                            options={choicevalue}
                                            styles={{ dropdown: { width: '100%' } }}
                                        />
            );
        });
    }
    else if(customitem.FieldType=='User'){
        let choicevalue=[];
        this.props.UserList.forEach(p=>{
        choicevalue.push({key:p.Id.toString(),text:p.Name});
        Rendervalue=(
            <Dropdown
                                        label={customitem.FieldTitle}
                                        selectedKey={customitem.LookUpId}
                                        onChange={(event: React.FormEvent<HTMLDivElement>, item: IDropdownOption)=>{  
                                            customitem.FieldValue=item.key.toString()  ;
                                            customitem.LookUpId=item.key.toString()  ;
                                            this.setState({changed:true});                                          
                                         
                                        }}
                                        //placeholder={'select status field'}
                                        options={choicevalue}
                                        styles={{ dropdown: { width: '100%' } }}
                                    />
        );
    });
}
else if(customitem.FieldType=='Note'){
  //https://github.com/jpuri/react-draft-wysiwyg/blob/master/src/config/defaultToolbar.js
  /*debugger
  const [editorState, setEditorState] =React.useState(() =>
    EditorState.createEmpty()
  );
  React.useEffect(() => {
    console.log(editorState);
  }, [editorState]);
  const convertedFromHTML = convertFromHTML(customitem.FieldValue);
    const contentState = ContentState.createFromBlockArray(convertedFromHTML.contentBlocks,
      convertedFromHTML.entityMap);
  let editorState= convertToRaw(contentState);

<Editor
  defaultContentState={contentState}
        onContentStateChange={setContentState}
  toolbarClassName="toolbarClassName"
  wrapperClassName="wrapperClassName"
  editorClassName="editorClassName"
  //onEditorStateChange={this.onEditorStateChange}
  onChange={(contentState: RawDraftContentState)=>{
    debugger
    this.props.OnChange(contentState);
}}
  toolbar={{
    inline: { inDropdown: true ,
      options:[
        "bold",
      "italic",
      "underline",
      ]
    },
    blockType:{className:'hidentools'},
    list:{inDropdown: true},
    link:{className:'hidentools'},
    history:{className:'hidentools'},
    fontFamily:{className:'hidentools'},
    emoji:{className:'hidentools'},
    image:{className:'hidentools'},
    remove:{className:'hidentools'}
    
    //list: { inDropdown: true,options:[] },
    //textAlign: { inDropdown: true },
    //link: { inDropdown: true },
    //history: { inDropdown: true }
  }}
/>

  */
  Rendervalue=(
    <React.Fragment>
      <label className="ms-Label">{customitem.FieldTitle}</label>
      <div className="mslistrichedittor">
        <MIPARichTextEdit datevalue={customitem.FieldValue} OnChange={(newvalue)=>{
          customitem.FieldValue=newvalue;
          //console.log(newvalue);
        }} />
      </div>
    </React.Fragment>

  );


    // Rendervalue=(
    //    <TextField
    //     type="text" 
    //     multiline={true}
    //     cols={3}
    //         onChange={(event)=>{
    //             customitem.FieldValue=event.target["value"];
    //         }}  
    //         value={customitem.FieldValue}
    //         label={customitem.FieldTitle}
    //         //placeholder="Site URL"
    //     /> 
        
    //   );
}      
        else{
          Rendervalue=(
            <TextField
            type="text" 
                onChange={(event)=>{
                    customitem.FieldValue=event.target["value"];
                }}  
                value={customitem.FieldValue}
                label={customitem.FieldTitle}
                //placeholder="Site URL"
            />
          );
        }
        data.push(
          
            <div key={"Custom_" + index} className="ms-Grid-col ms-sm6" style={{marginTop:8}} >
              {Rendervalue}
            </div>
         
        );
        
      }
    });
    return data;
  };
  public UpdateItemData=()=>{
    let fields:Array<MSListFieldValue>=[];
    this.Itemvalue.Fields.map((customitem:MSListFieldValue, index) => {
        if(this.ignoreDataType.indexOf(customitem.FieldType)<0){
            let fielddata:MSListFieldValue={
                FieldName:customitem.FieldName,
                FieldValue:customitem.FieldValue,
                FieldType:customitem.FieldType,
                FieldTitle:customitem.FieldTitle,
                IDValue:this.props.ListItem.ID
              };
              fields.push(fielddata)
        }
      });
    this.props.UpdateMethod(fields);
  }
  
}
